import { PureComponent } from 'react';
import { connect } from 'react-redux';
import mixpanelManager from '../helpers/mixpanelManager';
import { EMPTY_OBJECT_READONLY, CONTEXT_ID } from '../config/constants';
import { getBaseProperties } from '../saga';
import { mixpanelIdentityPath, mixpanelIdentity } from '../config';
import _once from 'lodash/once';
/*
for multiple mixpanel project tracking,
set mixpanel projectId in your env to be of form of
id1:projectA#id2:projectB#id3:projectC
*/
class RegisterTracking extends PureComponent {
  constructor(props) {
    super(props);
    const {
      user: { id: userId, name, email },
    } = this.props;
    let mixpanelId = `${userId}`;
    mixpanelManager.init(mixpanelId, { userId, name, email });
  }
  componentDidMount() {
    const {
      contextData,
      globalCommonData,
      user: { email },
    } = this.props;
    mixpanelManager.setParams({
      contextData,
      ...globalCommonData,
      isMindtickleUser: email.indexOf('mindtickle.com') > -1,
      company_design: 'new',
    });
  }
  render() {
    return this.props.children;
  }
}
const mapStateToProps = globalState => {
  const mixpanelParams = mixpanelManager.params;
  const contextData = getContextData(globalState, mixpanelParams);
  const globalCommonData = getGlobalCommonData(globalState);
  return contextData ? { globalCommonData, contextData } : EMPTY_OBJECT_READONLY;
};

const getContextData = (store, params = {}) => {
  let contextData = {};
  if (params.hasOwnProperty(CONTEXT_ID)) {
    const contextId = params[CONTEXT_ID];
    const contextPath = (store[contextId] && store[contextId].mixpanel) || {};
    contextData = getBaseProperties(contextPath, mixpanelIdentity.get(), store);
  }
  return contextData;
};
const getGlobalCommonData = _once(globalState =>
  getBaseProperties(mixpanelIdentityPath, mixpanelIdentity.get(), globalState)
);

export default connect(mapStateToProps, null)(RegisterTracking);
